module.exports = __webpack_public_path__ + "static/media/ReportMail.62977c1b.png";